"use strict";
/**
 * productManageMentAppExternalSysModule Module
 *
 * Description 外联模块管理
 * Author:fanglijuan 2016-11-04
 */
angular.module('productManageMentAppTagManagerModule', []).
controller('productManageMentAppTagManagerController', ['$scope', '$q', '$state', '$stateParams', '$modal', 'trsHttpService', 'modalDialog', 'trsspliceString', 'productMangageMentAppService', 'editingCenterService',
    function($scope, $q, $state, $stateParams, $modal, trsHttpService, modalDialog, trsspliceString, productMangageMentAppService, editingCenterService) {
        initStatus();
        initData();
        /**
         * [initStatus description]初始化状态
         */
        function initStatus() {
            $scope.data = {
                items: [],
                selectedArray: [],
                copyCurrPage: 1,
                siteMsg: "",
            };
        }
        /**
         * [initData description]初始化数据
         */
        function initData() {
            requestData();
            getBtnRights();
            editingCenterService.getSiteInfo($stateParams.site).then(function(data) {
                $scope.data.siteMsg = data;
            });
        }
        /**
         * [getBtnRights 获取标签管理按钮权限]
         * @return {[type]} [description]
         */
        function getBtnRights() {
            productMangageMentAppService.getRight($stateParams.site, "", "appsetsite.label").then(function(data) {
                $scope.status.right = data;
            });
        }

        /**
         * [selectAll description:全选]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            cancelBatchOperate();
        };

        /**
         * [selectDoc 单选]
         * @param  {[type]} item [description：单个对象] 
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
            cancelBatchOperate();
        };
        /**
         * [cancelBatchOperate description：取消批量操作的样式]
         */
        function cancelBatchOperate() {
            if ($scope.data.selectedArray.length === 0) {
                $scope.status.batchOperateBtn = {
                    "hoverStatus": "",
                    "clickStatus": ""
                };
            }
        }
        /**
         * [requestData description:数据请求方法]
         */
        function requestData() {
            var params = {
                serviceid: "mlf_appconfig",
                methodname: "queryLabels",
                SiteId: $stateParams.site,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.data.items = data;
                $scope.data.selectedArray = [];
            });
        }
        /**
         * [add description 新增弹窗]
         */
        $scope.addOrModify = function(item) {
            productMangageMentAppService.newTag(item || "", $stateParams.site, function(data) {
                requestData();
            });
        };
        /**
         * [deleteGroup description]单个删除
         */
        $scope.delete = function(item) {
            modalDialog.confirmModal("删除标签", "是否确认删除该标签", function() {
                var params = {
                    serviceid: "mlf_appconfig",
                    methodname: "delLabel",
                    APPLABELIDS: !!item ? item.APPLABELID : trsspliceString.spliceString($scope.data.selectedArray, "APPLABELID", ","),
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    modalDialog.alertType("删除成功", "", "success", false, function() {
                        requestData();
                    });
                });
            });
        };
        /**
         * [positionToChannel description]定位到栏目
         * @return null [description]
         */
        $scope.positionToSite = function(siteMsg) {
            $state.go("manageconfig.productmanage.app.channel", { site: siteMsg.SITEID }, { reload: true });
        };
    }
]);
